import React from "react";
import { useFetch, PageHeader, Loading } from "@/components/common";
import { Card } from "@/components/ui/card";

export default function People({ role }) {
  const { data: users, loading } = useFetch("/users", [role]);
  const title = role === "parent" ? "Parents" : "Coaches";
  const filterRoles = role === "parent" ? ["parent"] : ["coach", "assistant_coach"];
  const list = (users || []).filter((u) => filterRoles.includes(u.role));

  return (
    <div>
      <PageHeader title={title} subtitle={`${title} accounts and portal access`} testid={`${role}-page`} />
      {loading ? <Loading /> : list.length === 0 ? (
        <Card className="p-12 text-center text-muted-foreground">No {title.toLowerCase()} yet. Add them from the Users page.</Card>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {list.map((u) => (
            <Card key={u.id} className="p-5 flex items-center gap-4" data-testid={`${role}-card-${u.id}`}>
              <div className="h-12 w-12 rounded-full bg-emerald-500 text-white flex items-center justify-center font-bold text-lg">{u.name?.[0]?.toUpperCase()}</div>
              <div className="min-w-0">
                <div className="font-semibold truncate">{u.name}</div>
                <div className="text-sm text-muted-foreground truncate">{u.email}</div>
                <span className="text-xs px-2 py-0.5 rounded-full bg-secondary mt-1 inline-block">{u.role_label}</span>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
